import { render, staticRenderFns } from "./MobileForm.vue?vue&type=template&id=adb9ed96&scoped=true&"
import script from "./MobileForm.vue?vue&type=script&lang=js&"
export * from "./MobileForm.vue?vue&type=script&lang=js&"
import style0 from "./MobileForm.vue?vue&type=style&index=0&id=adb9ed96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb9ed96",
  null
  
)

export default component.exports